import { NgModule } from '@angular/core';

// modules
import { DfFormlyModule, DfIconModule } from '@lib/fresco';
import { LayoutModule } from '@app/layout/layout.module';
import { SharedModule } from '@app/shared/shared.module';

// components
import { CreateReportModalComponent } from './components/create-report-modal/create-report-modal.component';
import { DownloadableReportsComponent } from './components/downloadable-reports/downloadable-reports.component';
import { ReportingCreateReportParametersComponent } from './../components/reporting-create-report-parameters/reporting-create-report-parameters.component';

// services
import { DownloadableReportsApiService } from './services/downloadable-reports-api.service';
import { DownloadableReportsModalsService } from './services/downloadable-reports-modals.service';

/**
 * NOTE: Eager loaded through ReportingSharedModule > AppModule
 */
@NgModule({
  declarations: [
    CreateReportModalComponent,
    DownloadableReportsComponent,
    ReportingCreateReportParametersComponent,
  ],
  imports: [DfFormlyModule.forRoot(), DfIconModule, LayoutModule, SharedModule],
  providers: [DownloadableReportsApiService, DownloadableReportsModalsService],
  exports: [DownloadableReportsComponent],
})
export class ReportingDownloadableSharedModule {}
